import { Box, Divider, Stack } from "@mui/material";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";

import { useAppDispatch, useAppSelector } from "hooks/store";
import { Typography } from "new-components/typography/Typography";
import { getUserState } from "store/slices/Auth/authSlice";
import { getDataLimit } from "store/slices/DataLimit/dataLimitSlice";
import { getUserLimit } from "store/slices/UserLimit/userLimitSlice";
import { TierType } from "types/users";

export function LimitBanner() {
  const dispatch = useAppDispatch();
  const { data: userLimitData } = useAppSelector((state) => state.userLimit);
  const { data: dataLimit } = useAppSelector((state) => state.dataLimit);

  const isVisible = userLimitData.iqIsBlocked || userLimitData.escalationIsBlocked || userLimitData.detectorIsBlocked;

  useEffect(() => {
    dispatch(getUserLimit());
  }, [dispatch]);

  useEffect(() => {
    let intervalId: NodeJS.Timeout | undefined;
    if (isVisible) {
      dispatch(getDataLimit());
      intervalId = setInterval(() => {
        dispatch(getDataLimit());
      }, 5000); // Every 5 seconds
    } else if (intervalId) clearInterval(intervalId); // Clear the interval when the banner is not visible
    return () => {
      if (intervalId) clearInterval(intervalId); // Clear the interval when the component is unmounted
    };
  }, [isVisible, dispatch]);

  return isVisible ? (
    <Box className="bg-[#D33131] text-white p-2 flex flex-col md:flex-row justify-between items-center mb-6 gap-4 md:gap-0 px-2 sm:px-6 md:px-10">
      <Box className="flex gap-6 items-center">
        <Typography variant="subtitle" fontWeight="bold" textTransform="uppercase">
          Plan Limit Reached
        </Typography>
        <Stack
          direction="row"
          divider={<Divider orientation="vertical" color="white" className="h-[20px]" />}
          spacing={1}
          className="hidden md:flex items-center"
        >
          <Typography variant="small" fontWeight={userLimitData.detectorIsBlocked ? "bold" : "normal"}>
            {dataLimit?.active_detectors || "0"} / {dataLimit?.active_detectors_limit || "0"} Active Detectors
          </Typography>

          <Typography variant="small" fontWeight={userLimitData.escalationIsBlocked ? "bold" : "normal"}>
            {dataLimit?.escalations || "0"} / {dataLimit?.escalations_limit || "0"} Cloud Labels
          </Typography>

          <Typography variant="small" fontWeight={userLimitData.iqIsBlocked ? "bold" : "normal"}>
            {dataLimit?.iqs || "0"} / {dataLimit?.iqs_limit || "0"} Image Queries
          </Typography>
        </Stack>
      </Box>

      <Link to="/reef/my-account?service_plan_modal=true">
        <Box
          component="button"
          className="px-2 py-1 cursor-pointer rounded-xl text-[#D33131] bg-white hover:opacity-75 transition-all ease-linear"
        >
          <Typography fontWeight="semibold">Upgrade service plan</Typography>
        </Box>
      </Link>
    </Box>
  ) : null;
}

export function ExpirePlanBar() {
  const { tier } = useAppSelector(getUserState);

  if (tier === TierType.Unlimited) {
    return null;
  }

  return <LimitBanner />;
}
